<template>
  <div class="dashboard-box">
    <div class="dashboard-context">
      <div class="share-total">
        <!-- <div class="share-jobs">
          <span class="number">{{ dashboardData.jobShares }}</span>
          <span>{{ $t('personal.referrals.dashboard.label.jobShares') }}</span>
        </div> -->
        <div class="page-views">
          <span class="number">{{ dashboardData.pageViews }}</span>
          <span>{{ $t('personal.referrals.dashboard.label.pageViews') }}</span>
        </div>
      </div>
      <div class="potentail-total">
        <div v-if="companyHasSoftUserPremium" @click="toLeadsPage">
          <span class="type-text">{{ $t('personal.referrals.dashboard.potentialStatus.leads') }}</span>
          <span class="type-number">{{ dashboardData.leadsCount }}</span>
          <span><i class="el-icon-arrow-right"></i></span>
        </div>
        <!-- <div v-if="companyHasSoftUserPremium" @click="toLeadsPage">
          <span class="type-text">{{ $t('personal.referrals.dashboard.potentialStatus.prospects') }}</span>
          <span class="type-number">{{ dashboardData.prospects }}</span>
          <span><i class="el-icon-arrow-right"></i></span>
        </div> -->
        <div @click="toAppliedPage">
          <span class="type-text">{{ $t('personal.referrals.dashboard.potentialStatus.submitReferrals') }}</span>
          <span class="type-number">{{ dashboardData.submitReferralCount }}</span>
          <span><i class="el-icon-arrow-right"></i></span>
        </div>
      </div>
      <div class="applied-total">
        <div @click="toAppliedPage">
          <span class="type-text referral-title">
            {{ $t('personal.referrals.dashboard.label.referrals') }}
          </span>
          <span class="large-icon-arrow-right">
            <i class="el-icon-arrow-right"></i>
          </span>
        </div>
        <div v-for="(statusGroup, index) in dashboardData.statusGroupList" class="referral-status-box" :key="index">
          <span class="type-text">{{ $t(`admin.application.candidate.STATUS_GROUP.${statusGroup.name}`) }}</span>
          <span class="type-number">{{ statusGroup.count || 0 }}</span>
        </div>
      </div>
    </div>
    <div class="refer-button-box">
      <span class="iconfont">&#xe65a;</span>
      <div @click="toCompanyJobList">
        <span>{{ $t('personal.referrals.dashboard.label.referJobs') }}</span>
        <span class="small-title">{{ $t('personal.referrals.dashboard.label.referJobsText') }}</span>
      </div>
      <span class="large-icon" @click="toCompanyJobList">
        <i class="el-icon-arrow-right"></i>
      </span>
    </div>
    <div v-if="companyHasReferralPremium && !companyHiddenReferralRewards" class="refer-button-box">
      <span class="iconfont">&#xe662;</span>
      <div @click="toReferralRulePage">
        <span>{{ $t('personal.referrals.dashboard.label.referRules') }}</span>
      </div>
      <span class="large-icon" @click="toReferralRulePage">
        <i class="el-icon-arrow-right"></i>
      </span>
    </div>
    <div class="refer-button-box">
      <span class="iconfont">&#xe65c;</span>
      <div>
        <span>{{ $t('personal.referrals.dashboard.label.referFAQ') }}</span>
      </div>
      <span class="large-icon">
        <i class="el-icon-arrow-right"></i>
      </span>
    </div>
  </div>
</template>

<script>
import * as referralsRoute from '../referralsRoute'
import { mapActions } from 'vuex'

export default {
  props: {
    personalInfo: {
      required: true
    },
    companyHasReferralPremium: {
      type: Boolean,
      default: true
    },
    companyHasSoftUserPremium: {
      type: Boolean,
      default: true
    },
    companyHiddenReferralRewards: {
      type: Boolean,
      default: false
    }
  },
  components: {

  },
  data () {
    return {
      dashboardData: {
        leadsCount: 0,
        submitReferralCount: 0,
        jobShares: 0,
        pageViews: 0,
        prospects: 0,
        statusGroupList: []
      }
    }
  },
  created () {
    this.initData()
  },
  computed: {
    leadsRoute () {
      return referralsRoute.leadsRoute
    },
    appliedRoute () {
      return referralsRoute.leadsRoute.children[1]
    },
    referralRulesUrl () {
      return this.$DjangoBaseUrl('/referral/about-program/')
    }
  },
  mounted () {

  },
  methods: {
    ...mapActions('personal', ['getMyDashboardData']),
    async initData () {
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.getMyDashboardData({ company_id: this.$route.query.company_id })
        if (resp) {
          this.dashboardData = resp
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    toReferralRulePage () {
      window.location.href = this.referralRulesUrl
    },
    toLeadsPage () {
      this.$router.push({ path: this.leadsRoute.path, query: this.$route.query })
    },
    toAppliedPage () {
      this.$router.push({ path: this.appliedRoute.path, query: this.$route.query })
    },
    toCompanyJobList () {
      if (this.$route.query.company_id) {
        window.location.href = this.companyJobListUrl(this.$route.query.company_id)
      } else if (this.personalInfo?.employee) {
        window.location.href = this.companyJobListUrl(this.personalInfo.employee.company.id)
      } else {
        window.location.href = this.$DjangoBaseUrl('/jobseekers/')
      }
    },
    companyJobListUrl (companyId) {
      return this.$DjangoBaseUrl(`/mobile-web-more-jobs/${companyId}/`)
    }
  },
  watch: {

  }
}
</script>

<style lang="scss" scoped>
.dashboard-box {

  ::v-deep span {
    font-size: 14px;
    color: #666666;
    word-break: normal;
  }

  .dashboard-context {
    background-color: #FFFFFF;
    margin-top: 10px;
    border-radius: 5px;
    padding: 10px;
    justify-content: space-between;

    .share-total {
      display: flex;
      border-bottom: 1px solid #c3c3c3;
      padding: 20px;
      justify-content: space-around;

      > div {
        display: flex;
        flex-direction: column;
        align-items: center;

        > span {
          padding: 0;
          margin: 0;
        }

        .number {
          font-size: 40px;
        }
      }
    }

    .potentail-total {
      padding: 20px 10px 0 10px;

      .type-text {
        width: 82%;
      }

      > div {
        display: flex;

        > span {
          margin: 5px 0 10px 0;
        }

        .type-number {
          text-align: center;
          margin-right: 5px;
        }
      }
    }

    .applied-total {
      padding: 20px 10px 0 10px;

      > div {
        display: flex;
        align-items: center;
      }

      .referral-title {
        margin: 0 0 10px 0;
      }

      .large-icon-arrow-right {
        margin: 0 0 10px 0;

        > i {
          font-size: 26px;
        }
      }

      .referral-status-box {
        margin: 10px 0 10px 0;
      }
    }

    .type-text {
      width: 85%;
    }

    .type-number {
      width: 10%;
      font-size: 16px;
    }

    .referral-title {
      font-size: 18px;
      color: #333333;
    }
  }

  .large-icon {
    > i {
      font-size: 26px;
    }
  }

  .referr-large-icon {
    font-size: 36px;
    margin: 0 30px 0 10px;
    opacity: 0.5;
  }

  .el-icon-arrow-right {
    color: var(--custom-color);
  }

  .refer-button-box {
    background-color: #FFFFFF;
    margin: 10px 0 20px 0;
    padding: 20px;
    border-radius: 5px;
    display: flex;
    align-items: center;

    > div {
      width: 68%;
      margin-left: 20px;
      display: inline-grid;

      > span {
        margin: 0;
        font-size: 16px;
        color: #333333;
      }

      .small-title {
        font-size: 10px;
        color: #666666;
      }
    }

    .iconfont {
      font-size: 30px;
    }
  }
}
</style>
